var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "machine-vision-svgrepo-com-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #e6e6e6 } \n\t\t.s1 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m72.8 368h366.3c8.3 0 15-6.8 15-15v-11.1h-396.3v11.1c0 8.3 6.8 15 15 15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m37.9 111.4c0-19.3 15.6-35 35-35h366.3c19.3 0 34.9 15.7 34.9 35v241.6c0 19.3-15.6 35-35 35h-366.3c-19.3 0-34.9-15.7-34.9-35zm416.3 0c-0.1-8.2-6.8-15-15.1-15h-366.3c-8.2 0-14.9 6.8-14.9 15v241.6c0 8.2 6.7 15 15 15h366.3c8.2 0 14.9-6.8 14.9-15zm-115.1 324.1h-166c-5.5 0-10-4.5-10-10 0-5.5 4.5-10 10-10h166c5.5 0 10 4.5 10 10 0 5.5-4.5 10-10 10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m63.5 331.4c-1.3 0-2.7-0.6-3.6-1.6-1.9-2.1-1.8-5.2 0.3-7.1l118.3-109.8 53 58.1 129.4-145.4 91.9 98.2c1.9 2 1.8 5.2-0.2 7-2 1.9-5.2 1.8-7.1-0.2l-84.4-90.2-129.5 145.5-53.8-58.9-110.8 103c-1 0.9-2.3 1.4-3.5 1.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m218.4 360.1l-80.8-0.1c-2.5 0-4.5-2-4.5-4.5 0-2.5 2-4.5 4.5-4.5h80.8c2.5 0 4.5 2 4.5 4.5 0 2.5-2.1 4.5-4.5 4.5zm-108.1 0h-13.3c-2.5 0-4.5-2-4.5-4.5 0-2.5 2-4.5 4.5-4.5h13.3c2.5 0 4.5 2 4.5 4.5 0 2.5-2.1 4.5-4.5 4.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront);
export default __webpack_public_path__ + "static/media/front.4519e25e5ca4595e16c15fe6b073fcf6.svg";
export { ForwardRef as ReactComponent };